import axios from "../axios/AxiosInstance";
import { authenticationFingerprint } from "./authSession";
import { writeCandidateListCache } from "./candidateListCache";

const pending = new Map();

// La liste et le contrôle des documents partagent la lecture en cours.
// Chaque consommateur ignore sa réponse après démontage ; son annulation
// ne doit pas interrompre le téléchargement attendu par l’autre.
export function loadCandidateList() {
  const session = authenticationFingerprint();
  if (pending.has(session)) return pending.get(session);
  const request = axios.get("/tempworker-candidate/freelance")
    .then(({ data }) => {
      if (!Array.isArray(data)) throw new Error("La liste des candidats reçue est invalide.");
      writeCandidateListCache(data, session);
      return data;
    });
  pending.set(session, request);
  const clear = () => {
    if (pending.get(session) === request) pending.delete(session);
  };
  request.then(clear, clear);
  return request;
}
